import { z } from "zod";

export const EditDocumentSchema = z.object({
    status: z.string().min(1, { message: "Status é obrigatório!" }),
    linkdownload: z.string().min(1, { message: "Link é obrigatório!" }),
});
